import { BadgeContainer } from "./BadgeContainer";
import { Badge } from "./Badge";

export const Badges = {
  Container: BadgeContainer,
  Component: Badge,
}